import { cityRefArr } from "../../../../../server/api/src/router/reports/public/public.store";
import { calculateDistance } from "./find-distance-of-coordinates";

export function findClosestTopCity(latitude: number, longitude: number) {
  let closestTopCity;
  let closestDistance = Infinity;

  for (const key in cityRefArr) {
    const city = cityRefArr[key];
    const distance = calculateDistance(
      { lat: latitude, lon: longitude },
      { lat: city.lat, lon: city.lon },
    );
    if (distance < closestDistance) {
      closestDistance = distance;
      closestTopCity = city;
    }
  }
  return closestTopCity;
}
